/* Aviso de cookies propio (ADR-0012; docs/research/aviso-cookies-propio-especificacion-2026-10.md, §4). Lo pinta snippets/lp-cookies.liquid.
   El tema solo pone la cara: la elección la guarda Shopify con la Customer Privacy API (setTrackingConsent), que decide qué se activa.
   - Se enseña a quien no ha elegido (U5: a todo el mundo, sin mirar shouldShowBanner) o si el aviso tiene una versión más nueva que la de su
     elección (U3: localStorage «lp_cookies» = { v: versión, d: día }, sin identificadores). Al retirar un permiso, se recarga la página (U6).
   - Nunca lee ni escribe cookies, nunca llama a la API sin un clic y no toca sale_of_data. En el editor de temas no llama a la API.
   - No hace nada si el aviso nativo está en la página, si falta Shopify.loadFeatures o si la API no carga en 10 s.
   - Expone window.lpCookies.open(desde): el pie (lp-motion.js §5) y cualquier enlace a #preferencias-cookies abren el panel. */
(() => {
  const root = document.querySelector('[data-lp-cookies]');
  const panel = document.querySelector('[data-lp-cookies-panel]');
  if (!root || !panel || window.lpCookies || document.querySelector('script[src*="/privacy-banner/storefront-banner.js"]')) return;
  const KEYS = ['preferences', 'analytics', 'marketing'];
  const version = parseInt(root.dataset.version, 10) || 1;
  const html = document.documentElement;
  const main = document.getElementById('MainContent');
  const header = document.querySelector('.lp-header');
  const live = document.querySelector('[data-lp-cookies-live]');
  const wide = window.matchMedia('(min-width: 750px)');
  const all = (s) => document.querySelectorAll(s);
  const design = !!(window.Shopify && window.Shopify.designMode);
  const warn = (m) => window.console && console.warn('[lp-cookies] ' + m);
  let cp = null;
  let opener = null;
  let back = null;
  let raf = 0;
  let saving = false;

  const seen = () => {
    try {
      const r = JSON.parse(localStorage.getItem('lp_cookies') || 'null');
      return (r && r.v) || 0;
    } catch (e) {
      return -1; // sin almacenamiento: manda solo la elección guardada
    }
  };
  const consent = () => {
    try {
      return cp.currentVisitorConsent() || {};
    } catch (e) {
      return {};
    }
  };

  // Móvil: en la ficha (lp-ck--top) el borde de arriba sigue al de abajo de la cabecera; en las demás plantillas el aviso va abajo.
  // Mientras está abierto, scroll-padding para que lo enfocado no quede debajo (2.4.11)
  const place = () => {
    raf = 0;
    if (root.hidden) return;
    const top = !wide.matches && root.classList.contains('lp-ck--top');
    if (top) root.style.setProperty('--lp-ck-top', `${header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0}px`);
    const r = root.getBoundingClientRect();
    // la barra fija aparece y desaparece al bajar: se le guarda siempre su alto, aunque en este momento esté oculta
    const bar = document.querySelector('sticky-buy');
    html.style.scrollPaddingTop = top ? `${Math.round(r.bottom)}px` : '';
    html.style.scrollPaddingBottom = `${Math.round(top ? (bar ? parseFloat(getComputedStyle(bar).minHeight) || 0 : 0) : window.innerHeight - r.top)}px`;
  };
  const queue = () => raf || (raf = requestAnimationFrame(place));
  const show = (on) => {
    root.hidden = !on;
    [['scroll', queue], ['resize', queue]].forEach(([t, f]) => (on ? addEventListener(t, f, { passive: true }) : removeEventListener(t, f)));
    if (on) place();
    else html.style.scrollPaddingTop = html.style.scrollPaddingBottom = '';
  };
  const say = (text) => all('[data-lp-cookies-error]').forEach((el) => (el.textContent = text));
  const sync = () => {
    const c = consent();
    KEYS.forEach((k) => {
      const el = panel.querySelector(`[data-lp-cookies-cat="${k}"]`);
      if (el) el.checked = c[k] === 'yes';
    });
  };

  const open = (from) => {
    opener = from || document.activeElement;
    sync();
    say('');
    if (!panel.open) panel.showModal ? panel.showModal() : panel.setAttribute('open', '');
    panel.querySelector('[tabindex="-1"]').focus();
  };
  panel.addEventListener('close', () => {
    const to = back || opener;
    back = null;
    if (to && to.focus) to.focus({ preventScroll: true });
  });

  const save = (kind) => {
    if (saving || !cp) return;
    const pick = {};
    KEYS.forEach((k) => (pick[k] = kind === 'accept' || (kind === 'save' && !!panel.querySelector(`[data-lp-cookies-cat="${k}"]:checked`))));
    const before = consent();
    const first = !root.hidden;
    let done = false;
    const end = (res) => {
      if (done) return;
      done = true;
      saving = false;
      all('[data-lp-cookies-choice]').forEach((b) => b.removeAttribute('aria-disabled'));
      if (res && res.error) {
        warn('no se pudo guardar: ' + res.error);
        return say(root.dataset.error); // el aviso sigue: no se da por guardado
      }
      try {
        localStorage.setItem('lp_cookies', JSON.stringify({ v: version, d: new Date().toISOString().slice(0, 10) }));
      } catch (e) {}
      if (KEYS.some((k) => before[k] === 'yes' && !pick[k])) return window.location.reload(); // U6: para lo que ya estaba cargado
      show(false);
      back = first ? main : opener;
      if (panel.open) panel.close();
      else if (back) back.focus({ preventScroll: true });
      if (live) {
        live.textContent = '';
        setTimeout(() => (live.textContent = root.dataset.saved), 150);
      }
    };
    saving = true;
    say('');
    all('[data-lp-cookies-choice]').forEach((b) => b.setAttribute('aria-disabled', 'true'));
    const timer = setTimeout(() => end({ error: 'sin respuesta en 10 s' }), 10000);
    try {
      cp.setTrackingConsent(pick, (res) => {
        clearTimeout(timer);
        end(res);
      });
    } catch (e) {
      clearTimeout(timer);
      end({ error: e.message || 'excepción' });
    }
  };

  document.addEventListener('click', (e) => {
    const el = e.target.closest && e.target.closest('[data-lp-cookies-choice],[data-lp-cookies-open],[data-lp-cookies-close],a[href*="#preferencias-cookies"]');
    if (!el || (el.tagName === 'A' && !window.lpCookies)) return;
    if (el.tagName === 'A' || el.hasAttribute('data-lp-cookies-open')) {
      e.preventDefault();
      return open(el);
    }
    if (el.hasAttribute('data-lp-cookies-close')) return panel.close();
    if (el.getAttribute('aria-disabled') !== 'true') save(el.getAttribute('data-lp-cookies-choice'));
  });

  if (design) {
    // Editor de temas: nunca se llama a la API; el aviso solo se ve con el ajuste de vista previa
    if (root.hasAttribute('data-preview')) {
      window.lpCookies = { open };
      show(true);
    }
    return;
  }
  const S = window.Shopify;
  if (!S || typeof S.loadFeatures !== 'function') return warn('no hay Shopify.loadFeatures');
  let late = false;
  const wait = setTimeout(() => {
    late = true;
    warn('la API de privacidad no cargó en 10 s');
  }, 10000);
  S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
    clearTimeout(wait);
    if (late) return;
    if (err || !window.Shopify.customerPrivacy) return warn('la API de privacidad no cargó: ' + (err && (err.message || err)));
    cp = window.Shopify.customerPrivacy;
    window.lpCookies = { open };
    const c = consent();
    const v = seen();
    if (!KEYS.some((k) => c[k] === 'yes' || c[k] === 'no') || (v >= 0 && v < version)) show(true);
    document.addEventListener('visitorConsentCollected', () => panel.open && sync());
    if (window.location.hash === '#preferencias-cookies') open();
  });
})();
